import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
      themes: {
        light: {
          primary: '#3d4855',
          secondary: '#e35125',
          accent: '#8c9eff',
          error: '#b71c1c',
        },
      },
    },
});